import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ReportStockAuditrailPage } from './report-stock-auditrail.page';

const routes: Routes = [
  {
    path: '',
    component: ReportStockAuditrailPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReportStockAuditrailPageRoutingModule {}
